export default function Partnerships() {
  const products = [
    {
      icon: 'ri-drop-line',
      name: '마스크팩',
      description: '프리미엄 시트 마스크',
      image: 'https://static.readdy.ai/image/18ce7d978a53bc4b3d60c2ef96a81b06/dc70c5d86d8ef1f0859fb1ccef940ed9.png'
    },
    {
      icon: 'ri-hand-heart-line',
      name: '핸드크림',
      description: '영양 핸드 케어',
      image: 'https://static.readdy.ai/image/18ce7d978a53bc4b3d60c2ef96a81b06/f2e3541ce2ce451330c3a14e15acc4dd.jpeg'
    },
    {
      icon: 'ri-file-list-3-line',
      name: '한장샤워티슈',
      description: '편리한 바디 케어',
      image: 'https://static.readdy.ai/image/18ce7d978a53bc4b3d60c2ef96a81b06/9b9daf5b03cfa053b424968975e02716.png'
    }
  ];

  return (
    <section id="partnerships" className="py-24 lg:py-32 bg-amber-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            TRUSTED BY LEADING BRANDS
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            대한민국 대표 뷰티 기업과 함께하고 있습니다
          </p>
        </div>

        {/* AMOREPACIFIC Logo */}
        <div className="flex justify-center mb-16">
          <div className="bg-white px-16 py-12 rounded-2xl shadow-lg">
            <div className="text-5xl font-bold text-gray-400 tracking-wider">
              AMOREPACIFIC
            </div>
          </div>
        </div>

        {/* Product Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              {product.image ? (
                <div className="w-full h-48 flex items-center justify-center mb-6">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="h-full w-auto object-contain"
                  />
                </div>
              ) : (
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mb-6">
                  <i className={`${product.icon} text-3xl text-amber-700`}></i>
                </div>
              )}
              
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {product.name}
              </h3>
              
              <p className="text-sm text-gray-600">
                {product.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Text */}
        <div className="text-center">
          <p className="text-xl font-serif text-gray-700">
            함께 성장하는 파트너가 되겠습니다
          </p>
        </div>
      </div>
    </section>
  );
}